/*
  A small plugin to annoy people into returning
  to a tab which lost focus.

  Author: Tim Bauwens 2023
*/

import { bb } from "$json";

(doc => {
  const change = e => {
    let title = e.type === "blur" ? newTitle : originalTitle;
    doc.querySelector("head title").innerText = title;
  };
  const props = bb.propFinder(bb.conf.template, "change-title-on-tab-blur");
  const newTitle = props("new-title", "Come back!");

  const originalTitle = props(
    "original-title",
    doc.querySelector("head title").innerText
  );

  try {
    window.addEventListener("blur", change);
    window.addEventListener("focus", change);
  } catch (err) {
    window.console && window.console.error(err);
  }
})(document);
